import type { ComponentProps, ReactNode } from 'react';

import { Skeleton } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

interface Props extends ComponentProps<typeof Skeleton> {
  isLoading: boolean;
  children: ReactNode;
  width?: number | string;
  height?: number | string;
}

const ConditionalSkeleton = ({
  isLoading,
  children,
  width,
  height,
  style,
  className,
  ...skeletonProps
}: Props) => {
  return isLoading ? (
    <Skeleton
      {...skeletonProps}
      className={cn(
        width == null && 'w-full',
        height == null && 'h-[1.2em]',
        className,
      )}
      style={{ width, height, ...style }}
    />
  ) : (
    <>{children}</>
  );
};

export default ConditionalSkeleton;
